import { takeEvery, fork, put, all, call } from 'redux-saga/effects';

import { GET_DMX_DEVICE_PRESETS } from './actionTypes';
import { getDmxDevicePresetsSuccess, getDmxDevicePresetsError } from './actions';

import { getDmxAPI } from '../../../api/dmx';

const dmxAPI = getDmxAPI();

function* getDevicePresets({ payload: { user, deviceId } }) {
  try {
    const response = yield call(dmxAPI.getDevicePresets, user.token, deviceId);
    yield put(getDmxDevicePresetsSuccess(response));
  } catch (error) {
    yield put(getDmxDevicePresetsError(error));
  }
}

export function* watchGetDmxDevicePresets() {
  yield takeEvery(GET_DMX_DEVICE_PRESETS, getDevicePresets);
}

function* getDmxDevicePresetsSaga() {
  yield all([fork(watchGetDmxDevicePresets)]);
}

export default getDmxDevicePresetsSaga;
